export default __webpack_public_path__ + "static/media/logo.bf76613d.svg";